@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title | uppercase }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<div #errorContainer>
				@if (errorMessages.length !== 0) {
					<div>
						@for (error of errorMessages; track error) {
							<div>
								<div class="alert alert-warning" role="alert">{{ error }}</div>
							</div>
						}
					</div>
				}
			</div>
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					<p-messages [(value)]="messages"></p-messages>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n
						><strong>{{ 'general.vehicle' | translate }}</strong></label
					>
					<div class="p-0"></div>
					<p-select
						[options]="vehicleList"
						[(ngModel)]="entity.vehicle"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{ 'general.vehicle' | translate }}"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeVehicle($event)"
						(onFilter)="onFilterVehicle($event)"
						[disabled]="!formManipulation || !editVehicle"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.fine.driver' | translate }} (*)</strong>
					</label>
					<div class="p-0"></div>
					<p-select
						[options]="driverList"
						[(ngModel)]="entity.driver"
						placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.sinister.driver' | translate }}"
						dataKey="id"
						optionLabel="formatDriverLabel"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeDriver($event)"
						(onFilter)="onFilterDriver($event)"
						[disabled]="!formManipulation"
					>
						<ng-template let-driver pTemplate="item">
							<div class="flex align-items-center gap-2">
								<div>
									({{ driver.employee.code }}) {{ driver.employee.user.surname1 }}
									{{ driver.employee.user.surname2 }} {{ driver.employee.user.name }}
								</div>
							</div>
						</ng-template>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="referenceNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n
						><strong>{{ 'tableManagement.sinister.referenceNumber' | translate }} (*)</strong></label
					>
					<div class="p-0"></div>
					<input
						type="text"
						id="referenceNumber"
						class="form-control custom-input"
						[(ngModel)]="entity.referenceNumber"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="closed" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{ 'tableManagement.sinister.closed' | translate }}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.closed" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
				<div class="col-sm-4">
					<label for="sinisterDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.sinister.sinisterDate' | translate }} (*)</strong>
					</label>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="sinisterDate"
						[showTime]="false"
						[style]="{ width: '100%' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>
				<div class="col-sm-4">
					<label for="direction" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.workshop.direction' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="direction"
						class="form-control custom-input"
						[(ngModel)]="entity.direction"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="postalCode" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.workshop.cp' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="postalCode"
						class="form-control custom-input"
						[(ngModel)]="entity.postalCode"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-4">
					<label for="population" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.workshop.population' | translate }}
					</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="population"
						class="form-control custom-input"
						[(ngModel)]="entity.population"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-4">
					<label for="province" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.workshop.province' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="province"
						class="form-control custom-input"
						[(ngModel)]="entity.province"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="fleetManager" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.delegations.fleetManager' | translate
					}}</label>
					<div class="p-0"></div>
					<p-select
						[options]="fleetManagerList"
						[(ngModel)]="entity.fleetManager"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.delegations.fleetManager' | translate
						}}"
						dataKey="id"
						optionLabel="formatResponsibleLabel"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeFleetManager($event)"
						(onFilter)="onFilterFleetManager($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="sinisterType" class="form-label custom-label fw-bold small mb-2 me-2" i18n
						><strong> {{ 'tableManagement.sinister.sinisterType' | translate }} (*)</strong>
					</label>
					<div class="p-0"></div>
					<p-select
						[options]="sinisterTypeList"
						[(ngModel)]="entity.sinisterType"
						dataKey="id"
						optionLabel="name"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.sinister.sinisterType' | translate
						}}"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						(onChange)="onChangeSinisterType($event)"
						(onFilter)="onFilterSinisterType($event)"
						[disabled]="!formManipulation"
					>
					</p-select>
				</div>
				<div class="col-sm-4">
					<label for="statement" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.statement' | translate
					}}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.statement" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="statementNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.statementNumber' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="statementNumber"
						class="form-control custom-input"
						[(ngModel)]="entity.statementNumber"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-4">
					<label for="culpability" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.culpability' | translate }}
					</label>
					<div class="p-0"></div>
					<p-select
						[options]="modeCulpability"
						placeholder="{{ 'general.select' | translate }} {{
							'tableManagement.sinister.culpability' | translate
						}}"
						[(ngModel)]="entity.culpability"
						[style]="{ width: '250px' }"
						[disabled]="!formManipulation"
					></p-select>
				</div>
				<div class="col-sm-4">
					<label for="drugs" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{ 'tableManagement.sinister.drugs' | translate }}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.drugs" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="driverSanction" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.driverSanction' | translate
					}}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.driverSanction" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
				<div class="col-sm-4">
					<label for="sinisterTotal" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.sinisterTotal' | translate }}
					</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.sinisterTotal" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
				<div class="col-sm-4">
					<label for="healthcare" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.healthcare' | translate
					}}</label>
					<div class="p-0"></div>
					<p-toggleSwitch [(ngModel)]="entity.healthcare" [disabled]="!formManipulation"></p-toggleSwitch>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-4">
					<label for="expertDay" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.expertDay' | translate
					}}</label>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="expertDay"
						[showTime]="false"
						[style]="{ width: '100%' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>
			</div>
			<!-- SINISTER DETAILS -->
			<div class="row justify-content-start mt-3">
				<div class="col-12">
					<label for="sinisterDetails" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.sinisterDetails' | translate }}
					</label>
					<div class="p-0"></div>
					<textarea
						rows="2"
						cols="80"
						pInputTextarea
						class="w-100"
						[pTooltip]="entity.sinisterDetails"
						tooltipPosition="top"
						[(ngModel)]="entity.sinisterDetails"
						fitContent="true"
						[disabled]="!formManipulation"
					></textarea>
				</div>
			</div>
			<!-- INSURED DAMAGE -->
			<div class="row justify-content-start mt-3">
				<div class="col-12">
					<label for="insuredDamage" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.insuredDamage' | translate }}
					</label>
					<div class="p-0"></div>
					<textarea
						rows="2"
						cols="80"
						pInputTextarea
						class="w-100"
						[pTooltip]="entity.insuredDamage"
						tooltipPosition="top"
						[(ngModel)]="entity.insuredDamage"
						fitContent="true"
						[disabled]="!formManipulation"
					></textarea>
				</div>
			</div>
			<div class="container-fluid p-0 custom-panel">
				<!-- #region ROW 1: SINISTER NAV TABS -->
				<div class="row m-0 mt-4">
					<ul class="nav nav-tabs custom-nav-tabs">
						<li class="nav-item">
							<a
								href="#workshop"
								class="nav-link active p-0 custom-title custom-tab-title first-nav-tab"
								data-bs-toggle="tab"
							>
								<div class="d-flex align-items-center justify-content-center h-100">
									{{ 'tableManagement.sinister.workshop.title' | translate }}
								</div>
							</a>
						</li>
						<li class="nav-item">
							<a href="#counter" class="nav-link p-0 custom-title custom-tab-title" data-bs-toggle="tab">
								<div class="d-flex align-items-center justify-content-center h-100">
									{{ 'tableManagement.sinister.counter' | translate }}
								</div>
							</a>
						</li>
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#sinisterobservations"
									class="nav-link p-0 custom-title custom-tab-title"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'tableManagement.sinister.sinisterObservations' | translate }}
									</div>
								</a>
							</li>
						}
						@if (!isNew) {
							<li class="nav-item">
								<a
									href="#documentsSinister"
									class="nav-link p-0 custom-title custom-tab-title"
									data-bs-toggle="tab"
								>
									<div class="d-flex align-items-center justify-content-center h-100">
										{{ 'drivers.form.documents' | translate }}
									</div>
								</a>
							</li>
						}
					</ul>
				</div>
				<!-- WORKSHOP TAB CONTENT -->
				<div class="row m-0">
					<div class="tab-content p-0">
						<div class="tab-pane fade show active" id="workshop">
							<div class="container-fluid">
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="workshop" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.workshop.title' | translate
										}}</label>
										<div class="p-0"></div>
										<p-select
											[options]="workshopList"
											[(ngModel)]="entity.workshop"
											dataKey="id"
											placeholder="{{ 'general.select' | translate }} {{
												'tableManagement.sinister.workshop.title' | translate
											}}"
											optionLabel="name"
											[style]="{ width: '200px' }"
											appendTo="body"
											[filter]="true"
											(onChange)="onChangeWorkshop($event)"
											(onFilter)="onFilterWorkshop($event)"
											[disabled]="!formManipulation"
										>
										</p-select>
										<button
											class="btn custom-expand-button"
											type="button"
											i18n-alt alt="{{'tableManagement.sinister.workshop.createWorkshop' | translate}}"
											(click)="addWorkshop()"
										>
											<svg-icon
												class="d-flex m-0 p-0 custom-expand-button-icon"
												src="assets/icons/add.svg"
												[svgStyle]="{ 'height.px': 30, 'width.px': 30 }"
											></svg-icon>
										</button>
									</div>
									<div class="col-sm-4">
										<label for="workshopStartDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'tableManagement.sinister.workshopStartDate' | translate }}
										</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="workshopStartDate"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
									<div class="col-sm-4">
										<label for="workshopEndDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.workshopEndDate' | translate
										}}</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="workshopEndDate"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
								</div>
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="rentVehicleName" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.rentVehicleName' | translate
										}}</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="rentVehicleName"
											class="form-control custom-input"
											[(ngModel)]="entity.rentVehicleName"
											[disabled]="!formManipulation"
										/>
									</div>
									<div class="col-sm-4">
										<label for="vehiclePickupDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'tableManagement.sinister.vehiclePickupDate' | translate }}
										</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="vehiclePickupDate"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
									<div class="col-sm-4">
										<label for="vehicleReturnDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.vehicleReturnDate' | translate
										}}</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="vehicleReturnDate"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
								</div>
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="endReparationDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.endReparationDate' | translate
										}}</label>
										<div class="p-0"></div>
										<p-datepicker
											[(ngModel)]="endReparationDate"
											[showTime]="false"
											[style]="{ width: '100%' }"
											dateFormat="{{ i18n.dateFormat }}"
											showIcon="true"
											appendTo="body"
											[disabled]="!formManipulation"
										></p-datepicker>
									</div>
								</div>
							</div>
						</div>
						<!-- COUNTER TAB CONTENT -->
						<div class="tab-pane fade" id="counter">
							<div class="container-fluid">
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="counterName" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'general.name' | translate }}
										</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="counterName"
											class="form-control custom-input"
											[(ngModel)]="entity.counterName"
											[disabled]="!formManipulation"
										/>
									</div>
									<div class="col-sm-4">
										<label for="phoneNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.workshop.phoneNumber' | translate
										}}</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="phoneNumber"
											class="form-control custom-input"
											[(ngModel)]="entity.phoneNumber"
											[disabled]="!formManipulation"
										/>
									</div>
									<div class="col-sm-4">
										<label for="licensePlate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'control-panel.vehicles.licensePlate' | translate
										}}</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="licensePlate"
											class="form-control custom-input"
											[(ngModel)]="entity.licensePlate"
											[disabled]="!formManipulation"
										/>
									</div>
								</div>
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="brand" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'control-panel.vehicles.vehicleBrand.name' | translate }}
										</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="brand"
											class="form-control custom-input"
											[(ngModel)]="entity.brand"
											[disabled]="!formManipulation"
										/>
									</div>
									<div class="col-sm-4">
										<label for="model" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'control-panel.vehicles.vehicleModel.name' | translate
										}}</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="model"
											class="form-control custom-input"
											[(ngModel)]="entity.model"
											[disabled]="!formManipulation"
										/>
									</div>
									<div class="col-sm-4">
										<label for="company" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.company' | translate
										}}</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="company"
											class="form-control custom-input"
											[(ngModel)]="entity.company"
											[disabled]="!formManipulation"
										/>
									</div>
								</div>
								<div class="row mt-4 mb-4">
									<div class="col-sm-4">
										<label for="policyNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
											'tableManagement.sinister.policyNumber' | translate
										}}</label>
										<div class="p-0"></div>
										<input
											type="text"
											id="policyNumber"
											class="form-control custom-input"
											[(ngModel)]="entity.policyNumber"
											[disabled]="!formManipulation"
										/>
									</div>
								</div>
								<div class="row justify-content-start mt-3">
									<div class="col-12">
										<label for="insuredDamageCounter" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
											{{ 'tableManagement.sinister.insuredDamageCounter' | translate }}
										</label>
										<textarea
											rows="2"
											cols="80"
											pInputTextarea
											class="w-100"
											[pTooltip]="entity.insuredDamageCounter"
											tooltipPosition="top"
											[(ngModel)]="entity.insuredDamageCounter"
											fitContent="true"
											[disabled]="!formManipulation"
										></textarea>
									</div>
								</div>
							</div>
						</div>
						<!-- OBSERVATIONS TAB CONTENT -->
						<div class="tab-pane fade" id="sinisterobservations">
							<div class="container-fluid">
								@if (!isNew) {
									<div class="row mt-3">
										<app-observations-list
											[type]="observationType"
											[entityId]="entity.id"
											[ids]="idsObservations"
										></app-observations-list>
									</div>
								}
							</div>
						</div>
						<!-- DOCUMENTS TAB CONTENT -->
						<div class="tab-pane fade" id="documentsSinister">
							<div class="container-fluid">
								<!-- taula de documents -->
								@if (!isNew) {
									<div class="row mt-3">
										<app-doc-table
											type="sinister"
											[entity]="entity"
											[nested]="true"
											[ids]="ids"
											(return)="refresh()"
										>
										</app-doc-table>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
	<div class="d-flex justify-content-center bd-highlight">
		<div class="p-2 bd-highlight">
			@if (isNew) {
				<div>
					<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation" i18n>
						{{ 'general.create' | translate }}
					</button>
				</div>
			}
			@if (!isNew) {
				<div>
					<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation" i18n>
						{{ 'general.save' | translate }}
					</button>
				</div>
			}
		</div>
	</div>
</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}

<app-workshop-form></app-workshop-form>

